const orderDocuments = [
    {
        'text': 'Račun - dobavnica',
        'value': 1
    },
    {
        'text': 'Blagajniški prejemek',
        'value': 2
    }
];

function maskCardNumber(number) {
    let masked = '';
    let l = number.length;
    masked = number.substring(l - 4);
    while (masked.length < 13) {
        masked = '*' + masked;
    }
    return masked
}

export default {
    maskCardNumber,
    orderDocuments
}